
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'GHD',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/GHD.vue